import React, { useState } from "react";
import { Link } from "react-router-dom";

const BusCard = ({ imageUrl, destination, source, source_code }) => {
  const currentDate = new Date().toISOString().split("T")[0];

  return (
    <div className="ecpl_rbx">
      <div className="mgdestn">
        <Link>
          <img variant="top" src={imageUrl} alt={source} />
        </Link>
      </div>
      <div className="_pckgdscrptn">
        <h5 className="htlnking">
          <Link>{source}</Link>
        </h5>
        <div className="htlnking_buss">
          {destination.map((link, index) => {
            const url = `/buslisting?from=${encodeURIComponent(
              source
            )}&to=${encodeURIComponent(link.city)}&cityId=${source_code}&desId=${
              link.city_code
            }&journeyDate=${currentDate}`;
            return (
              <Link
                key={index}
                className="htlnking-link"
                to={url}
                style={{ marginRight: "6px" }}
              >
                {link.city}
                {index < destination.length - 1 ? "," : ""}
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

const BusTopSearch = () => {
  const [showAll, setShowAll] = useState(false);

  // 👇 Let's create 12+ cities to make the expand visible
const hotels = [
  {
    imageUrl: "https://images.emtcontent.com/hotel-img/blr-sm.webp",
    source: "Bengaluru",
    source_code: "6395",
    destination: [
      { city: "Hyderabad", city_code: "7485" },
      { city: "Mumbai", city_code: "1562" },
      { city: "Goa", city_code: "5900" },
      { city: "Chennai", city_code: "2069" },
      { city: "Pune", city_code: "7681" }
    ]
  },
  {
    imageUrl: "https://images.emtcontent.com/bus-img/hyd-sm.webp",
    source: "Hyderabad",
    source_code: "7485",
    destination: [
      { city: "Bengaluru", city_code: "6395" },
      { city: "Mumbai", city_code: "1562" },
      { city: "Goa", city_code: "5900" },
      { city: "Chennai", city_code: "2069" },
      { city: "Pune", city_code: "7681" }
    ]
  },
  {
    imageUrl: "https://images.emtcontent.com/bus-img/pune-sm.webp",
    source: "Pune",
    source_code: "7681",
    destination: [
      { city: "Bengaluru", city_code: "6395" },
      { city: "Goa", city_code: "5900" },
      { city: "Indore", city_code: "4252" },
      { city: "Nagpur", city_code: "1330" },
      { city: "Hyderabad", city_code: "7485" }
    ]
  },
  {
    imageUrl: "https://images.emtcontent.com/bus-img/chennai-sm.webp",
    source: "Chennai",
    source_code: "2069",
    destination: [
      { city: "Bengaluru", city_code: "6395" },
      { city: "Coimbatore", city_code: "6345" },
      { city: "Hyderabad", city_code: "7485" },
      { city: "Madurai", city_code: "3919" },
      { city: "Tirunelveli", city_code: "4141" }
    ]
  },
  {
    imageUrl: "https://images.emtcontent.com/hotel-img/del-sm.webp",
    source: "Delhi",
    source_code: "230",
    destination: [
      { city: "Manali", city_code: "4845" },
      { city: "Jaipur", city_code: "5222" },
      { city: "Amritsar", city_code: "8102" },
      { city: "Lucknow", city_code: "5318" },
      { city: "Shimla", city_code: "5641" }
    ]
  },
  {
    imageUrl: "https://images.emtcontent.com/hotel-img/mumb-sm.webp",
    source: "Mumbai",
    source_code: "1562",
    destination: [
      { city: "Bengaluru", city_code: "6395" },
      { city: "Hyderabad", city_code: "7485" },
      { city: "Indore", city_code: "4252" },
      { city: "Goa", city_code: "5900" },
      { city: "Pune", city_code: "7681" }
    ]
  },
  {
    imageUrl: "https://images.emtcontent.com/bus-img/indr-sm.webp",
    source: "Indore",
    source_code: "4252",
    destination: [
      { city: "Mumbai", city_code: "1562" },
      { city: "Pune", city_code: "7681" },
      { city: "Ahmedabad", city_code: "9331" },
      { city: "Ahmednagar", city_code: "7844" },
      { city: "Nagpur", city_code: "1330" }
    ]
  },
  {
    imageUrl: "https://images.emtcontent.com/hotel-img/ahmd-sm.webp",
    source: "Ahmedabad",
    source_code: "9331",
    destination: [
      { city: "Porbandar", city_code: "6358" },
      { city: "Jamnagar", city_code: "7154" },
      { city: "Udaipur", city_code: "8380" },
      { city: "Indore", city_code: "4252" },
      { city: "Rajkot", city_code: "8693" }
    ]
  },
  {
    imageUrl: "https://images.emtcontent.com/hotel-img/goa-sm.webp",
    source: "Goa",
    source_code: "5900",
    destination: [
      { city: "Hyderabad", city_code: "7485" },
      { city: "Bengaluru", city_code: "6395" },
      { city: "Pune", city_code: "7681" },
      { city: "Mumbai", city_code: "1562" },
      { city: "Kolhapur", city_code: "1362" }
    ]
  },
  {
    imageUrl: "https://images.emtcontent.com/hotel-img/combt-sm.webp",
    source: "Coimbatore",
    source_code: "6345",
    destination: [
      { city: "Chennai", city_code: "2069" },
      { city: "Bengaluru", city_code: "6395" },
      { city: "Hyderabad", city_code: "7485" },
      { city: "Tuticorin", city_code: "13022" },
      { city: "Sivakasi", city_code: "8905" }
    ]
  },
  {
    imageUrl: "https://images.emtcontent.com/bus-img/jaipur-sm.webp",
    source: "Jaipur",
    source_code: "5222",
    destination: [
      { city: "Delhi", city_code: "230" },
      { city: "Bikaner", city_code: "230" },
      { city: "Lucknow", city_code: "9718" },
      { city: "Jodhpur", city_code: "6287" },
      { city: "Indore", city_code: "4252" }
    ]
  },
  {
    imageUrl: "https://images.emtcontent.com/hotel-img/ngpr-sm.webp",
    source: "Nagpur",
    source_code: "1330",
    destination: [
      { city: "Pune", city_code: "7681" },
      { city: "Hyderabad", city_code: "7485" },
      { city: "Jalalkhera", city_code: "10160" },
      { city: "Indore", city_code: "4252" },
      { city: "Nanded", city_code: "Nanded" }
    ]
  }
];


  const visibleHotels = showAll ? hotels : hotels.slice(0, 9);

  return (
    <div
      style={{
        background: "#fff",
        position: "relative",
        zIndex: "100",
        padding: "5px"
      }}
    >
      <div className="container">
        <div className="slchtl_mn">
          <div className="pg_tle f28 wt600">
            Popular Bus Routes
          </div>

          {/* Animated container */}
          <div
            className={`_polrdestnbx mt20 animated-section ${
              showAll ? "open" : "closed"
            }`}
          >
            {visibleHotels.map((hotel, index) => (
              <BusCard key={index} {...hotel} />
            ))}
          </div>

          <div className="view_btn ctmrg" style={{ textAlign: "center" }}>
            <button
              onClick={() => setShowAll(!showAll)}
              className="view-more-btn"
            >
              {showAll ? "View Less" : "View More"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusTopSearch;
